import Vue from 'vue'
export function hasBtn(btnName)
{
    if (btnName=='btn_add') {
        return true
    }
    var btn = sessionStorage.getItem('btnList') ? JSON.parse(sessionStorage.getItem('btnList')) : [];
    if (btn.length==0){
        return null
    }else {
        var link=[];
        btn.forEach(function(e,i) {
            link[i]=e.link;
        });
        return link.indexOf(btnName) > -1;
    }
}
export function getBtnStatus(path) {
    this.$post('admin_base_api/login',{path:path}).then((res)=>{
        if (res.status == 200){
            sessionStorage.setItem('btnList',res.data);
        }else {
            this.$message.error(res.message)
        }
        
    })
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function api_imgurl(value) {
    var API_IMGURL = process.env.API_IMG_URL;
    return API_IMGURL+value;
}
// 库位/库格打印
export function warehouse_location(data){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",500,500,"");
        LODOP.SET_PRINT_PAGESIZE(2,500,300,"");
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        LODOP.ADD_PRINT_IMAGE(0,6,90,90,"<img src='"+data.qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
        var top=80;
        LODOP.ADD_PRINT_TEXT(top,10,110,60,data.name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
        if (data.print_cnt) {
            LODOP.SET_PRINT_COPIES(data.print_cnt);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        }
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
    }
}
// 配件打印
export function material_parts(data){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",500,500,"");
        LODOP.SET_PRINT_PAGESIZE(2,500,300,"");
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        LODOP.ADD_PRINT_IMAGE(0,6,90,90,"<img src='"+data.qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
        var top=80;
        if(data.code){
            LODOP.ADD_PRINT_TEXT(top,10,110,22,data.code);
            LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
            top+=20;
        }
        if(data.material_code){
            LODOP.ADD_PRINT_TEXT(top,10,110,22,data.material_code);
            LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
            top+=20;
        }
        var name = '';
        if(data.name){
            name+=data.name;
        }
        if (data.spec) {
            name += '('+data.spec+')'
        }
        if (data.model) {
            name += '('+data.model+')'
        }
        var goods_shelves_number_code='';
        if (data.goods_shelves_material&&data.goods_shelves_material.length>0) {
            name += '\r\n'+data.goods_shelves_material[0].goods_shelves_number_code
        }
        if(data.material_name){
            name += data.material_name
        }
        if(data.material_model){
            name += '('+data.material_model+')'
        }
        if(data.warehouse_name){
            name += '\r\n'+data.warehouse_name
        }
        if(data.goods_shelves_ge_code){
            name += data.goods_shelves_ge_code
        }
        if(data.goods_shelves_number_code){
            name += data.goods_shelves_number_code
        }
        LODOP.ADD_PRINT_TEXT(top,10,110,80,name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
        if (data.print_cnt) {
            LODOP.SET_PRINT_COPIES(data.print_cnt);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        }
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
    }
}


// 打印出库单
export function outbound_order(data,height,resolve){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小
        LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
        // LODOP.ADD_PRINT_IMAGE(0,5,800,height,"<img src='"+data+"'>");
        LODOP.ADD_PRINT_URL(0,5,800,height,data);


       
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
        if (resolve) {
            resolve();
        }
    }
}

// 领料单
export function material_requisition1(data,resolve){
    LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小
    LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
    // LODOP.ADD_PRINT_URL(0,5,800,height,data);



    // LODOP.ADD_PRINT_HTM(0,0,'210mm','297mm',document.getElementById("imageWrapper").innerHTML);
    // LODOP.ADD_PRINT_TABLE(0,0,'210mm','297mm',document.getElementById("imageWrapper").innerHTML);

    LODOP.ADD_PRINT_IMAGE(0,0,120,120,data.outbound_qr_code);
    LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
    var top=30;
    LODOP.ADD_PRINT_TEXT(top,5,800,60,"发（领）料单");
    top+=50;
    LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
    LODOP.SET_PRINT_STYLEA(0,"Bold",1);
    LODOP.ADD_PRINT_TEXT(top,5,800,30,"物资分类："+data.material_category_name);
    top+=30
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",3);

    LODOP.ADD_PRINT_TEXT(top,5,800,30,"存放地点：");
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",1);

    LODOP.ADD_PRINT_TEXT(top,5,800,30,data.info.created);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

    LODOP.ADD_PRINT_TEXT(top,5,800,30,"单号："+data.info.code);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
    top+=30

    LODOP.ADD_PRINT_TEXT(top,5,800,30,"领料部门："+data.info.department_name);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",1);
    LODOP.ADD_PRINT_TEXT(top,5,800,30,"工号："+data.info.code);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
    LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
    top+=30

    var style="<style>table{margin: 5px 0; width: 100%; table-layout:fixed;border-collapse:collapse; border: solid 1px #ebeef5; } table tr td{border: solid 1px #ebeef5; text-align: center; font-size: 14px; padding:5px 5px; } </style>";
    var html=document.getElementById("table_table").innerHTML;
    LODOP.ADD_PRINT_TABLE(top,5,800,840,style+html);
    LODOP.SET_PRINT_STYLEA(0,"Offset2Top",-40);

    top+=800;

    LODOP.ADD_PRINT_TEXT(top,5,105,30,"主管经理：");
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    if (data.manage_sign) {
        LODOP.ADD_PRINT_IMAGE(top,120,100,40,data.manage_sign);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    }else{
        LODOP.ADD_PRINT_TEXT(top,120,100,30,data.manage_name);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    }

    LODOP.ADD_PRINT_TEXT(top,220,85,30,"请领人：");
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    if (data.staff_sign) {
        LODOP.ADD_PRINT_IMAGE(top,305,100,40,data.staff_sign);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    }else{
        LODOP.ADD_PRINT_TEXT(top,305,100,30,data.staff_name);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    }

    LODOP.ADD_PRINT_TEXT(top,405,85,30,"收料人：");
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    if (data.receive_sign) {
        LODOP.ADD_PRINT_IMAGE(top,490,100,40,data.receive_sign);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    }else{
        LODOP.ADD_PRINT_TEXT(top,490,100,30,data.receive_staff_name);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    }

    LODOP.ADD_PRINT_TEXT(top,590,85,30,"发料人：");
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    if (data.give_sign) {
        LODOP.ADD_PRINT_IMAGE(top,675,100,40,data.give_sign);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    }else{
        LODOP.ADD_PRINT_TEXT(top,675,100,30,data.give_staff_name);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    }
    top+=40;


    LODOP.ADD_PRINT_TEXT(top,5,85,30,"制单人：");
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    if (data.make_staff_sign) {
        LODOP.ADD_PRINT_IMAGE(top,90,100,40,data.make_staff_sign);
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    }else{
        LODOP.ADD_PRINT_TEXT(top,90,100,30,data.make_staff_name);
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
    }
    top+=40;
    LODOP.ADD_PRINT_TEXT(top,5,800,30,'注：请领人为部室/车间负责人');
    LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);
    LODOP.SET_PRINT_STYLEA(0,"FontSize",14);

    // LODOP.PRINT_DESIGN();
    // LODOP.PREVIEW();
    LODOP.PRINT();
    if (resolve) {
        resolve();
    }
}
export function material_requisition(data,dataURL,resolve,title='发（领）料单',id='table_table'){
    var LODOP = this.$getLodop();
    if (LODOP) {
        var style="<style>table{margin: 5px 0; width: 100%; table-layout:fixed;border-collapse:collapse; border: solid 1px #ebeef5; } table tr td{border: solid 1px #ebeef5; text-align: center; font-size: 14px; padding:5px 5px; } .dayin_html{padding: 10px 0; } .dayin_html .p1{text-align: center; font-size: 30px; font-weight: bold; position: relative; } .dayin_html .p1 .img{width: 120px; position: absolute; top: -45px; left: 0; } .dayin_html .p2{text-align: right; font-size: 16px; padding-right: 20px; line-height: 30px; } .dayin_html .p3{font-size: 16px; padding:5px 0; display: flex; justify-content: space-between; } .dayin_html .p5{font-size: 16px; padding:5px 0; display: flex; align-items: center; justify-content: space-between; } .dayin_html .p5 .img, .dayin_html .p5 img{width: 100px; height: 50px; background-position: center; background-repeat: no-repeat; background-size: contain; object-fit: contain; display: inline-block; vertical-align: middle; } .dayin_html .p5 .img_name{display: inline-block; min-width: 100px; } .dayin_html .p4{font-size: 16px; margin-top: 10px; } .dayin_html .table_table{margin: 5px 0; width: 100%; table-layout:fixed;border-collapse:collapse; border: solid 1px #ebeef5; } .dayin_html .table_table tr td{border: solid 1px #ebeef5; text-align: center; font-size: 14px; padding:5px 5px 0; }</style>";
        LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小
        LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
        var top=30;

        LODOP.ADD_PRINT_IMAGE(0,0,120,120,"<img src='"+data.outbound_qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
        var top=30;
        LODOP.ADD_PRINT_TEXT(top,5,740,60,title);
        top+=50;
        LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
        LODOP.SET_PRINT_STYLEA(0,"Bold",1);
        LODOP.ADD_PRINT_TEXT(top,5,740,30,"物资分类："+data.material_category_name);
        top+=30;
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);

        LODOP.ADD_PRINT_TEXT(top,5,740,30,"存放地点：");
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",1);

        LODOP.ADD_PRINT_TEXT(top,5,740,30,data.info.created);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

        LODOP.ADD_PRINT_TEXT(top,5,740,30,"单号："+data.info.code);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
        top+=30;

        LODOP.ADD_PRINT_TEXT(top,5,740,30,"领料部门："+data.info.department_name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",1);
        LODOP.ADD_PRINT_TEXT(top,5,740,30,"工号："+data.info.code);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",16);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
        top+=30;

        var html1=document.getElementById(id).innerHTML;
        LODOP.ADD_PRINT_TABLE(top,5,740,940,style+html1);
        LODOP.SET_PRINT_STYLEA(0,"Offset2Top",-140);
        LODOP.ADD_PRINT_IMAGE(0,5,740,130,dataURL);
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);

        // LODOP.PREVIEW();
        LODOP.PRINT();
        if (resolve) {
            resolve();
        }
    }

}



export function getTime(/** timestamp=0 **/) {  
    const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='yue'){
        return y+'-'+(m<10?'0'+m:m);
    }else if(arguments[1]=='hh:ii:ss'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);
    }else if(arguments[1]=='week'){
        return days[t.getDay()];
    }else if(arguments[1]=='yyyy'){
        return y+'';
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}
export function IMG_URL(img) {
    if (img.indexOf('http')!=-1) {
        return img
    }else{
        return process.env.API_IMG_URL + img;
    }
}
export function IMG_URL_SHOW(img) {
    var img_array=img.split('.');
    var type_array=['jpg','jpeg','png','gif','bmp','JPG','JPEG','PNG','GIF','BMP'];
    var img_type=img_array[img_array.length-1];
    if (type_array.indexOf(img_type)!=-1) {
        if (img.indexOf('http')!=-1) {
            return img
        }else{
            return process.env.API_IMG_URL + img;
        }
    }else{
        return '/static/img/file.png'
    }
}

export function router_url(url, query) {
    var date = new Date().getTime();
    var query_obj = {
        t: date
    };
    if (query) {
        query['t'] = date;
    } else {
        query = query_obj
    }
    this.$router.push({
        path:url,
        query:query
    })
}
/**
 * 获取屏幕高度
 * @param {number} height 要减去的高度
 * @return {number}
 */
export function screenHeight(height = 0) {
    // header70   tag62 router_view30  form65  table_kuang20  button_kuang68   page66
    // var deduct=70+62+30+65+20+68+66;
    // header70   tag62 router_view30  form47  table_kuang0  button_kuang48   page46
    var deduct=70+62+30+47+0+48+46;
    var defaultHeight = 880
    var winHeight;
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
    }
    if (winHeight) {
        return winHeight - height - deduct
    } else {
        return defaultHeight - height - deduct
    }
}
export const formatRoutes = (aMenu,aRouter) => {
    aMenu.forEach(oMenu => {
        const {link, name, Menu,menu_type,sort } = oMenu
        if(Menu&&Menu.length>0){
            formatRoutes(Menu,aRouter);
        }
        if(link&&menu_type=='2'){
            var text = link.replace('_', '/');
            const oRouter = {
                path:link,
                name:name+link+sort,
                component:loadView(text),
            }
            aRouter.push(oRouter)
        }
    })
    return aRouter
}
export const loadView = (view) => {
    return resolve => require([`@/views/${view}`], resolve).catch(err => {})
}
/**
 * 是否外链
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:)/.test(path);
}

export function unique(array) {
    var res = [];
    for (var i = 0, arrayLen = array.length; i < arrayLen; i++) {
        for (var j = 0, resLen = res.length; j < resLen; j++ ) {
            if (array[i] === res[j]) {
                break;
            }
        }
        if (j === resLen) {
            res.push(array[i])
        }
    }
    return res;
}


// WEBPACK FOOTER //
// ./store/store.js